export default {"src":"/_next/static/media/kinetic_cat_ic.ccb87c2a.svg","height":120,"width":120};